$(function(){
  
  if($("body.template-customers-register").length > 0){
    let searchParams = new URLSearchParams(window.location.search)
    if (searchParams.has('ReferralCode')) {
      let param = searchParams.get('ReferralCode');
      localStorage.setItem("ReferralCode", param);
    }else{
      localStorage.setItem("ReferralCode", '');
    }
    
  }
  
  
  $(document).on("click", "#change-pw-octocode a", function(){
    
    let regSpaces = /^\s+$/;
    let customerId = $("#customer-id").val();
    let pw = $("#change-pw-octocode #change-pw").val();
    let pwr = $("#change-pw-octocode #change-pw-r").val();
    let url = 'https://sebastianyatra.com/apps/proxy';
    
    if(pw.length < 6 || regSpaces.test(pw)){
      $("#change-pw-octocode #change-pw").focus();
      Swal.fire({
        title: 'Escribe una contraseña.',
        html: 'Mayor a 5 caracteres.',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
                 
    if(pwr.length < 6 || regSpaces.test(pwr)){
      $("#change-pw-octocode #change-pw-r").focus();
      Swal.fire({
        title: 'Escribe la confirmación de contraseña.',
        html: 'Igual a la contraseña.',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
    
    if(pw != pwr){
      $("#change-pw-octocode #change-pw").focus();
      Swal.fire({
        title: 'Contraseña y confirmación de contraseña deben ser iguales',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
    let data = {
      "customerId":customerId,
      "password":pw,
      "action": "changepassword"
    }
    $("#loader-ajax-per").show();
    fetch(url, {
      method: 'POST', // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers:{
        'Content-Type': 'application/json'
      }
    }).then(res => res.json())
    .catch(error => changePWError(error))
    .then(response => changePWSuccess(response));
  });
  
  
  $(document).on("click", "#change-pw-octocode > p", function(){
    $(this).parent().toggleClass("active");
  });
  
  
  $(document).on("click", "#streaming-events-octo > .event > a", function(){
    $("#loader-ajax-per").show();
    $("#popup-streaming-octocode").remove();
    let currEventId = $(this).attr("data-event-id");
    let productUrl = $(this).attr("data-product-url");
    let productTitle = $(this).attr("data-product-title");
    let customerId = $("#customer-id").val();
    let url = 'https://sebastianyatra.com/apps/proxy';
    let data = {
      "customer_id":customerId,
      "stream_id":currEventId,
      "action": "checkstreamaccess"
    }
    fetch(url, {
      method: 'POST', // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers:{
        'Content-Type': 'application/json'
      }
    }).then(res => res.json())
    .catch(error => streamingAccessError(error))
    .then(response => streamingAccessSuccess(response, currEventId, productUrl, productTitle));
  });
  
  $(document).on("click", "#popup-streaming-octocode button", function(){
    $("#loader-ajax-per").show();
    let currEventId = $("#popup-streaming-octocode").attr("data-event-id");
    let customerId = $("#customer-id").val();
    let code = $("#popup-streaming-octocode input").val().toUpperCase();
    let url = 'https://sebastianyatra.com/apps/proxy';
    let data = {
      "customer_id":customerId,
      "stream_id":currEventId,
      "code":code,
      "action": "validatecodeaccess"
    }
    fetch(url, {
      method: 'POST', // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers:{
        'Content-Type': 'application/json'
      }
    }).then(res => res.json())
    .catch(error => validateCodeAccessError(error))
    .then(response => validateCodeAccessSuccess(response, currEventId));
  });
  
  $(document).on("click", "#popup-streaming-octocode .close", function(){
    $("#popup-streaming-octocode").remove();
  });
  
  $(document).on("click", "#popup-streaming-octocode", function(){
    $("#popup-streaming-octocode").remove();
  });

  $(document).on("click", "#popup-streaming-octocode > div", function(e){
    e.stopPropagation();
  });
    
  if($("#reg-birthday").length > 0){
    const input = document.getElementById('reg-birthday');
    const datepicker = new TheDatepicker.Datepicker(input);
    datepicker.render();
  }
  
  if($("body.template-customers-account").length > 0){
    let customerId = $("#customer-id").val();
    let url = 'https://sebastianyatra.com/apps/proxy';
    let data = {
      "customerId":customerId,
      "action": "getGameball"
    }
    fetch(url, {
      method: 'POST', // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers:{
        'Content-Type': 'application/json'
      }
    }).then(res => res.json())
    .catch(error => getGameballError(error))
    .then(response => getGameballSuccess(response));
    //formAction = getGameball
      
    let data2 = {
      "action": " getupcomingevents"
    }
    fetch(url, {
      method: 'POST', // or 'PUT'
      body: JSON.stringify(data2), // data can be `string` or {object}!
      headers:{
        'Content-Type': 'application/json'
      }
    }).then(res => res.json())
    .catch(error => getStreamingError(error))
    .then(response => getStreamingSuccess(response));
  }
  
  if($("body.template-customers-register").length > 0){
    let code = localStorage.getItem("ReferralCode");
    if(code !== ''){
      $("input#ReferralCode").val(code);
    }
    /*let searchParams = new URLSearchParams(window.location.search)
    if (searchParams.has('ReferralCode')) {
        let param = searchParams.get('ReferralCode');
        $("input#ReferralCode").val(param);
    }*/
    
  }
  
  fetch('https://quuorapublishing.theoctocode.com/api/v1/countries2')
  .then(function(response) {
    return response.json();
  })
  .then(function(myJson) {
    $("#reg-country").append(`<option data-countryCode="yatra" value="01010101" selected>--Selecciona país--</option>`);
    $.each(myJson, function(i, order){
      $("#reg-country").append(`<option data-id="${myJson[i].id}" data-code-conutry="${myJson[i].phone}" data-countryCode="${myJson[i].sortname}" value="${myJson[i].name}">${myJson[i].name}</option>`)
    });
  });
  
  if($("#accout-edit-inline #upd-country").length > 0){
    let currCountry = $("#accout-edit-inline #upd-country").prev().find("span").text();
    $(`#accout-edit-inline #upd-country option[value='${currCountry}']`).attr("selected","selected");
  }
  
  $(document).on("click", "#verify-account-octo-btn", function(e){
    let regEmail = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,3})$/;
    let regEmailVal = $("#verify-email").val().toLowerCase();
    
    if(!regEmail.test(regEmailVal)){
      $("#verify-email").focus();
      Swal.fire({
        title: 'Escribe un correo.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
    $("#loader-ajax-per").fadeIn();
    let data = {
      "email":regEmailVal,
      "action": "searchcustomer"
    }
    let url = 'https://sebastianyatra.com/apps/proxy';
    fetch(url, {
      method: 'POST', // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers:{
        'Content-Type': 'application/json'
      }
    }).then(res => res.json())
    .catch(error => verifyAccountError(error))
    .then(response => verifyAccountSuccess(response));
  });

  $(document).on("click", "#verify-email-code-octo-btn", function(e){
    let regEmailCodeVal = $("#verify-email-code").val();
    if(regEmailCodeVal === '' || regEmailCodeVal === undefined){
      $("#verify-email-code").focus();
      Swal.fire({
        title: 'Escribe el código de verificación',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
    $("#loader-ajax-per").fadeIn();
    let data = {
      code: regEmailCodeVal,
      email:$(".email-current").text(),
      action: "validateemailcode"
    }
    let url = 'https://sebastianyatra.com/apps/proxy';
    fetch(url, {
      method: 'POST', // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers:{
        'Content-Type': 'application/json'
      }
    }).then(res => res.json())
    .catch(error => verifyCodeEmailError(error))
    .then(response => verifyCodeEmailSuccess(response));
  });
  
  $("#create-account-octo-btn").on("click", function(e){
    
    e.stopPropagation();
    
    let regSpaces = /^\s+$/;
    let regEmail = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,3})$/;
    var regNumbers = /^([0-9])*$/;
    
    let regName = $("#reg-name").val();
    if(regName.length < 2 || regSpaces.test(regName)){
      $("#reg-name").focus();
      Swal.fire({
        title: 'Escribe tu nombre.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
    
    let regLastName = $("#reg-last-name").val();
    if(regLastName.length < 2 || regSpaces.test(regLastName)){
      $("#reg-last-name").focus();
      Swal.fire({
        title: 'Escribe tus apellidos.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
  
    let regCountryCode = $("#reg-country-code").val();

    if(regCountryCode === null){
      Swal.fire({
        title: 'No se puede registrar de tu país',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
    }

    let regCountry = $("#reg-country").val();

    if(regCountry == "01010101"){
      $("#reg-country").focus();
      Swal.fire({
        title: 'Selecciona un país',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
    
    let regState = $("#reg-state").val();
    if(regState == "01010101"){
      $("#reg-state").focus();
      Swal.fire({
        title: 'Selecciona un estado',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }

    let regPhone = $("#reg-phone").val();
    if(regSpaces.test(regPhone) || regPhone.length < 6 || !regNumbers.test(regPhone)){
      $("#reg-phone").focus();
      Swal.fire({
        title: 'Escribe un teléfono.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
    
    let regBirthday = $("#reg-birthday").val();
    
    if(regBirthday == ''){
      $("#reg-birthday").focus();
      Swal.fire({
        title: 'Pon la fecha de tu cumpleaños.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
    let arrayregBirthday = regBirthday.split(". ");
    regBirthday = `${arrayregBirthday[2]}-${arrayregBirthday[1]}-${arrayregBirthday[0]}`;
    let gender = $(`input[name="gender"]:checked`).val();
    if(gender == undefined){
      Swal.fire({
          title: 'Selecciona tu género.',
          html: '',
          onBeforeOpen: () => {
        },
          onClose: () => {
        }
      })
      return false;
    }
    
    let regEmailVal = $("#reg-email").val().toLowerCase();
    if(!regEmail.test(regEmailVal)){
      $("#reg-email").focus();
      Swal.fire({
        title: 'Escribe un correo.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
    
    let regPassword = $("#reg-password").val();
    if(regPassword.length < 6 || regSpaces.test(regPassword)){
      $("#reg-password").focus();
      Swal.fire({
        title: 'Escribe una contraseña.',
        html: 'Mayor a 5 caracteres.',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
  
    let regPassword2 = $("#reg-password2").val();
    if(regPassword2.length < 6 || regSpaces.test(regPassword2)){
      $("#reg-password2").focus();
      Swal.fire({
        title: 'Escribe la confirmación de contraseña.',
        html: 'Igual a la contraseña.',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
    
    if(regPassword != regPassword2){
      $("#reg-password").focus();
      Swal.fire({
        title: 'Contraseña y confirmación de contraseña deben ser iguales',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
    

    let regInstagram = "";
    
    let regInstagramVal = $("#reg-instagram").val();
    if(regInstagramVal.length > 0){
      regInstagram = "https://www.instagram.com/"+regInstagramVal;
    }
    
    let regTwitter = "";
    let regTwitterVal = $("#reg-twitter").val();
    if(regTwitterVal.length > 0){
      regTwitter = "https://twitter.com/"+regTwitterVal;
    }

    let regFacebook = "";
    let regFacebookVal = $("#reg-facebook").val();
    if(regFacebookVal.length > 0){
      regFacebook = "https://www.facebook.com/"+regFacebookVal;
    }

    let condiciones = $("#reg-terms-conditions").is(":checked");
    
    if (!condiciones) {
      Swal.fire({
        title: 'Acepta los términos y condiciones.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
    
    
    let privacyPolicy = $("#reg-privacy-policy").is(":checked");
    
    if (!privacyPolicy) {
      Swal.fire({
        title: 'Acepta política de privacidad.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
    
    let url = 'https://sebastianyatra.com/apps/proxy';
    
    let dataverifysms = {
      "action": "verifysms",
      "country":`+${regCountryCode}`,
      "phone": regPhone
    }

    verifysms(url,dataverifysms);

  });

  $("#update-account-octo-btn").on("click", function(e){
    
    e.stopPropagation();
    
    let regSpaces = /^\s+$/;
    let regEmail = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,3})$/;
    var regNumbers = /^([0-9])*$/;
    
    let regName = $("#reg-name").val();
    if(regName.length < 2 || regSpaces.test(regName)){
      $("#reg-name").focus();
      Swal.fire({
        title: 'Escribe tu nombre.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
    
    let regLastName = $("#reg-last-name").val();
    if(regLastName.length < 2 || regSpaces.test(regLastName)){
      $("#reg-last-name").focus();
      Swal.fire({
        title: 'Escribe tus apellidos.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
  
    let regCountryCode = $("#reg-country-code").val();

    if(regCountryCode === null){
      Swal.fire({
        title: 'No se puede registrar de tu país',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
    }

    let regCountry = $("#reg-country").val();

    if(regCountry == "01010101"){
      $("#reg-country").focus();
      Swal.fire({
        title: 'Selecciona un país',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
    
    let regState = $("#reg-state").val();
    if(regState == "01010101"){
      $("#reg-state").focus();
      Swal.fire({
        title: 'Selecciona un estado',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }

    let regPhone = $("#reg-phone").val();
    if(regSpaces.test(regPhone) || regPhone.length < 6 || !regNumbers.test(regPhone)){
      $("#reg-phone").focus();
      Swal.fire({
        title: 'Escribe un teléfono.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
    
    let regBirthday = $("#reg-birthday").val();
    if(regBirthday == ''){
      $("#reg-birthday").focus();
      Swal.fire({
        title: 'Pon la fecha de tu cumpleaños.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
    let arrayregBirthday = regBirthday.split(". ");
    regBirthday = `${arrayregBirthday[2]}-${arrayregBirthday[1]}-${arrayregBirthday[0]}`;
    
    let gender = $(`input[name="gender"]:checked`).val();
    if(gender == undefined){
      Swal.fire({
          title: 'Selecciona tu género.',
          html: '',
          onBeforeOpen: () => {
        },
          onClose: () => {
        }
      })
       return false;
    }
    
    let regEmailVal = $("#reg-email").val().toLowerCase();
    if(!regEmail.test(regEmailVal)){
      $("#reg-email").focus();
      Swal.fire({
        title: 'Escribe un correo.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
    
    let regInstagram = "";
    
    let regInstagramVal = $("#reg-instagram").val();
    if(regInstagramVal.length > 0){
      regInstagram = "https://www.instagram.com/"+regInstagramVal;
    }
    
    let regTwitter = "";
    let regTwitterVal = $("#reg-twitter").val();
    if(regTwitterVal.length > 0){
      regTwitter = "https://twitter.com/"+regTwitterVal;
    }

    let regFacebook = "";
    let regFacebookVal = $("#reg-facebook").val();
    if(regFacebookVal.length > 0){
      regFacebook = "https://www.facebook.com/"+regFacebookVal;
    }

    let condiciones = $("#reg-terms-conditions").is(":checked");
    
    if (!condiciones) {
      Swal.fire({
        title: 'Acepta los términos y condiciones.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      return false;
    }
    
    let url = 'https://sebastianyatra.com/apps/proxy';
    
    let dataverifysms = {
      "action": "verifysms",
      "country":`+${regCountryCode}`,
      "phone": regPhone
    }

    verifysms(url,dataverifysms);

  });
  
  $(document).on("click", "#new-code-btn", function(e){
    let url = 'https://sebastianyatra.com/apps/proxy';
    let regCountryCode = $("#reg-country-code").val();
    let regPhone = $("#reg-phone").val();
    let dataverifysms = {
      "action": "verifysms",
      "country":`+${regCountryCode}`,
      "phone": regPhone
    }
    verifysms(url,dataverifysms);
  });

  $(document).on("click", "#veryfy-code-btn", function(e){
    e.stopPropagation();
    let codeVerify = $("#code-verify").val();
    $("#sms_code").val(codeVerify)
    let url = 'https://sebastianyatra.com/apps/proxy';
    let regCountryCode = $("#reg-country-code").val();
    let regPhone = $("#reg-phone").val();
    let dataverifycode = {
      "action": "verifycode",
      "country":`+${regCountryCode}`,
      "phone": regPhone,
      "code": codeVerify
    }
    $("#loader-ajax-per").fadeIn();
    if($("body.template-customers-account").length > 0){
      fetch(url, {
        method: 'POST', // or 'PUT'
        body: JSON.stringify(dataverifycode), // data can be `string` or {object}!
        headers:{
          'Content-Type': 'application/json'
        }
      }).then(res => res.json())
      .catch(error => verifycode2Error(error))
      .then(response => verifycode2Success(response));
    }else{
      fetch(url, {
        method: 'POST', // or 'PUT'
        body: JSON.stringify(dataverifycode), // data can be `string` or {object}!
        headers:{
          'Content-Type': 'application/json'
        }
      }).then(res => res.json())
      .catch(error => verifycodeError(error))
      .then(response => verifycodeSuccess(response));
    }
    
  });
  
  $(document).on("click", "#link-reg-terms-conditions", function(e){
    e.preventDefault();
    $("#reg-terms-conditions-pop").fadeIn();
  });

  $(document).on("click", "#reg-terms-conditions-pop > div > span.close", function(){
    $("#reg-terms-conditions-pop").hide();
  });

  $(document).on("click", "#reg-terms-conditions-pop", function(){
    $("#reg-terms-conditions-pop").hide();
  });
  
  $(document).on("click", "#reg-terms-conditions-pop > div", function(e){
    e.stopPropagation();
  });

  $(document).on("click", "#link-reg-privacy-policy", function(e){
    e.preventDefault();
    $("#reg-privacy-policy-pop").fadeIn();
  });

  $(document).on("click", "#reg-privacy-policy-pop > div > span.close", function(){
    $("#reg-privacy-policy-pop").hide();
  });

  $(document).on("click", "#reg-privacy-policy-pop", function(){
    $("#reg-privacy-policy-pop").hide();
  });

  $(document).on("click", "#reg-privacy-policy-pop > div", function(e){
    e.stopPropagation();
  });

  $(document).on("click", ".link-mision-get-info", function(e){
    e.preventDefault();
    let currId = $(this).attr("data-id-mision");
    $("#fixed-mision-info > div").html("");
    $(`#status-misiones-octocode > .mision-number-${currId}`).each(function( index ){
      let currHTML = $(this).html();
      $("#fixed-mision-info > div").append(currHTML);
    });
    $("#fixed-mision-info").addClass("active");
    $("#gb_container_8247439015").hide();
  });

  $(document).on("click", "#fixed-mision-info > img", function(){
    $("#fixed-mision-info > div").html("");
    $("#fixed-mision-info").removeClass("active");
    $("#gb_container_8247439015").show();
  });

  $(document).on("click", "#reg-phone-code-pop > div > span.close", function(){
    $("#reg-phone-code-pop").hide();
  });

  $('#reg-country').on('change', function(){
    let currVal = $('#reg-country option:selected').attr('data-countrycode');
    let currCode = $('#reg-country option:selected').attr('data-code-conutry');
    let currIdCountry = $('#reg-country option:selected').attr('data-id');
    let currValChange = $(`#reg-country-code option[data-countrycode="${currVal}"]`).val();
    let arrCodes  = JSON.parse("[" + currCode + "]");
    $("#reg-country-code").html("");
    for (let value of arrCodes) {
      $("#reg-country-code").append(`<option value="${value}">(+${value})</option>`)
    }
    $("#reg-country-code option:first-child").attr("selected");
    fetch(`https://quuorapublishing.theoctocode.com/api/v1/states2/${currIdCountry})`)
    .then(function(response) {
      return response.json();
    })
    .then(function(myJson) {
      $("#reg-state option").remove();
      $("#reg-state").append(`<option value="01010101" selected>--Selecciona un estado--</option>`);
      $.each(myJson, function(i, order){
        $("#reg-state").append(`<option value="${myJson[i].name}">${myJson[i].name}</option>`)
      });
      
    });
  });

  /*$('#reg-country-code').on('click', function(){
    let currVal = $('#reg-country-code option:selected').attr('data-countrycode');
    let currValChange = $(`#reg-country option[data-countrycode="${currVal}"]`).val();
    $("#reg-country").val(currValChange).change();
  });*/

  $('#accout-edit-inline .gender input[name="gender"]').change(function(){
    let currval = $('#accout-edit-inline .gender input[name="gender"]:checked').val();
    let customerId = $("#accout-edit-inline #customer-id").val();
    let data = {
      "customer_id":customerId,
      "gender": currval,
      "action": "editAccount"
    }
    let url = 'https://sebastianyatra.com/apps/proxy';
    fetch(url, {
      method: 'POST', // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers:{
        'Content-Type': 'application/json'
      }
    }).then(res => res.json())
    .catch(error => updateAccountError(error))
    .then(response => updateAccountSuccess(response));
  });

  $('#accout-edit-inline .com_text').click(function(){
    var com_text = $(this).attr('id');
  });
  //Edit
  $('#accout-edit-inline .edit').click(function(e){ 
    e.preventDefault();
    $(this).hide();
    $(this).parent().prev().find('.name').hide();
    $(this).parent().prev().find('input').show();
    $(this).parent().prev().find('select').show();
    $(this).next('.save').show();
    $(this).next().next('.cancel').show();
    $(com_text).val($('.name').text().trim()); 
  });
  //Cancel
  $('#accout-edit-inline .cancel').click(function(e){
    e.preventDefault();
    $(this).hide();
    $(this).parent().prev().find('.name').show();
    $(this).parent().prev().find('input').hide();
    $(this).parent().prev().find('select').hide();
    $(this).prev().hide();
    $(this).prev().prev().show();
    $(com_text).hide();
  });
  //Save
  $('#accout-edit-inline .save').click(function(e){
    e.preventDefault();
    let regSpaces = /^\s+$/;
    let regEmail = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,3})$/;
    var regNumbers = /^([0-9])*$/;
    
    let sname ="";
    let currid = "";
    
    if($(this).parent().prev().find('input').length > 0){
      sname = $(this).parent().prev().find('input').val().trim();
      currid = $(this).parent().prev().find('input').attr("id");
    }
    
    if($(this).parent().prev().find('select').length > 0){
      sname = $(this).parent().prev().find('select').val().trim();
      currid = $(this).parent().prev().find('select').attr("id");
    }
    
    let customerId = $("#accout-edit-inline #customer-id").val();
    let data = {}
    if(currid == "upd-name"){
      if(sname.length < 2 || regSpaces.test(sname)){
        Swal.fire({
          title: 'Escribe tu nombre.',
          html: '',
          onBeforeOpen: () => {
          },
          onClose: () => {
          }
        })
        return false;
      }
      data = {
        "customer_id":customerId,
        "name": sname,
        "action": "editAccount"
      }
    }
    if(currid == "upd-last-name"){
      if(sname.length < 2 || regSpaces.test(sname)){
        Swal.fire({
          title: 'Escribe tus apellidos.',
          html: '',
          onBeforeOpen: () => {
          },
          onClose: () => {
          }
        })
        return false;
      }
      data = {
        "customer_id":customerId,
        "lastName": sname,
        "action": "editAccount"
      }
    }
    if(currid == "upd-email"){
      if(!regEmail.test(sname)){
        Swal.fire({
          title: 'Escribe un correo.',
          html: '',
          onBeforeOpen: () => {
          },
          onClose: () => {
          }
        })
        return false;
      }
      data = {
        "customer_id":customerId,
        "email": sname,
        "action": "editAccount"
      }
    }
    if(currid == "upd-birthday"){
      if(sname == ''){
        Swal.fire({
          title: 'Pon la fecha de tu cumpleaños.',
          html: '',
          onBeforeOpen: () => {
          },
          onClose: () => {
          }
        })
        return false;
      }
      data = {
        "customer_id":customerId,
        "birthday": sname,
        "action": "editAccount"
      }
    }
    if(currid == "upd-instagram"){
      data = {
        "customer_id":customerId,
        "instagram": sname,
        "action": "editAccount"
      }
    }
    if(currid == "upd-twitter"){
      data = {
        "customer_id":customerId,
        "twitter": sname,
        "action": "editAccount"
      }
    }
    if(currid == "upd-facebook"){
      data = {
        "customer_id":customerId,
        "facebook": sname,
        "action": "editAccount"
      }
    }
    if(currid == "upd-country"){
      data = {
        "customer_id":customerId,
        "country": sname,
        "action": "editAccount"
      }
    }
    
    
    let url = 'https://sebastianyatra.com/apps/proxy';
    fetch(url, {
      method: 'POST', // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers:{
        'Content-Type': 'application/json'
      }
    }).then(res => res.json())
    .catch(error => updateAccountError(error))
    .then(response => updateAccountSuccess(response));
    
    
    $(this).parent().prev().find('.name > span').text(sname);
    $(this).parent().prev().find('.name').show();
    $(this).parent().prev().find('input').hide();
    $(this).parent().prev().find('select').hide();
    $(this).prev().show();
    $(this).next().hide();
    $(this).hide();
    $("#Perfil > #accout-edit-inline > .edit-this > .btns > a > span > i").addClass("hide");
    $(this).prev().find('span').append("<img class='loader-inline' src='https://cdn.shopify.com/s/files/1/0399/6162/4742/files/loadinfo.gif?v=1594410467' alt='loader' />");
    
    
  });

});

function verifysms(url,dataverifysms){
  $("#loader-ajax-per").fadeIn();
  let regCountryCode = $("#reg-country-code").val();
  let regPhone = $("#reg-phone").val();
  fetch(url, {
    method: 'POST', // or 'PUT'
    body: JSON.stringify(dataverifysms), // data can be `string` or {object}!
    headers:{
      'Content-Type': 'application/json'
    }
  }).then(res => res.json())
  .catch(error => verifysmsError(error))
  .then(response => verifysmsSuccess(response, regCountryCode, regPhone));
}

function verifysmsError(err){
  console.log(err);
  Swal.fire({
    title: 'No se verificó el número telefónico.',
    html: '',
    onBeforeOpen: () => {
    },
    onClose: () => {
    }
  })
  $("#loader-ajax-per").fadeOut();
}
function verifysmsSuccess(res, countryCode, phone){
  if(res.status === "success"){
    $("#sms_code").val($('#code-verify').val())
    $("#reg-phone-code-pop").fadeIn();
    $("#reg-phone-code-pop>div .form-code > p").html("");
    $("#reg-phone-code-pop>div .form-code > p").html(`Se envío un código de verificación al número: +${countryCode} ${phone}`);
  }else{
    if(res.status === "failed"){
       Swal.fire({
        title: 'El número de teléfono ya esta en uso en otra cuenta.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
    }else{
      Swal.fire({
        title: 'Ocurrio un error intente mas tarde.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
    }
  }
  $("#loader-ajax-per").fadeOut();
}

function verifycodeError(err){
  console.log(err);
  Swal.fire({
    title: 'Ocurrio un error intente mas tarde.',
    html: '',
    onBeforeOpen: () => {
    },
    onClose: () => {
    }
  })
  $("#loader-ajax-per").fadeOut();
}
function verifycodeSuccess(res){
  if(res.status === "success"){
    $("#loader-ajax-per").fadeIn();
    let regName = $("#reg-name").val();
    let regLastName = $("#reg-last-name").val();
    let regCountryCode = $("#reg-country-code").val();
    let regPhone = $("#reg-phone").val();
    let regBirthday = $("#reg-birthday").val();
    let arrayregBirthday = regBirthday.split(". ");
    regBirthday = `${arrayregBirthday[2]}-${arrayregBirthday[1]}-${arrayregBirthday[0]}`;
    let gender = $(`input[name="gender"]:checked`).val();
    let regEmailVal = $("#reg-email").val().toLowerCase();
    let regPassword = $("#reg-password").val();
    let regCountry = $("#reg-country").val();
    let regState = $("#reg-state").val();
    let ReferralCode = $("#ReferralCode").val();
    let regInstagram = "";
    let regInstagramVal = $("#reg-instagram").val();
    if(regInstagramVal.length > 0){
      regInstagram = "https://www.instagram.com/"+regInstagramVal;
    }
    let regTwitter = "";
    let regTwitterVal = $("#reg-twitter").val();
    if(regTwitterVal.length > 0){
      regTwitter = "https://twitter.com/"+regTwitterVal;
    }
    let regFacebook = "";
    let regFacebookVal = $("#reg-facebook").val();
    if(regFacebookVal.length > 0){
      regFacebook = "https://www.facebook.com/"+regFacebookVal;
    }
    let condiciones = $("#reg-terms-conditions").is(":checked");
    let data = {
      "email":regEmailVal,
      "password":regPassword,
      "countryCode":regCountryCode,
      "phone":regPhone,
      "name":regName,
      "lastName":regLastName,
      "birthday":regBirthday,
      "gender":gender,
      "instagram": regInstagram,
      "twitter": regTwitter,
      "facebook": regFacebook,
      "country": regCountry,
      "state": regState,
      "ReferralCode":ReferralCode,
      "action": "requestAccount2",
      "email_code": $("#email_code").val(),
      "sms_code": $("#sms_code").val()
    }
    console.log(data)
    let url = 'https://sebastianyatra.com/apps/proxy';
    fetch(url, {
      method: 'POST', // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers:{
        'Content-Type': 'application/json'
      }
    }).then(res => res.json())
    .catch(error => createAccountError(error))
    .then(response => createAccountSuccess(response));
  }else{
    if(res.status === "failed"){
       Swal.fire({
        title: 'El código no es válido.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      $("#code-verify").val("");
      $("#loader-ajax-per").fadeOut();
    }else{
      Swal.fire({
        title: 'Ocurrio un error intente mas tarde.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      $("#code-verify").val("");
      $("#loader-ajax-per").fadeOut();
    }
    
  }
}

function verifycode2Error(err){
  console.log(err);
  Swal.fire({
    title: 'Ocurrio un error intente mas tarde.',
    html: '',
    onBeforeOpen: () => {
    },
    onClose: () => {
    }
  })
  $("#loader-ajax-per").fadeOut();
}
function verifycode2Success(res){
  if(res.status === "success"){
    $("#loader-ajax-per").fadeIn();
    let regName = $("#reg-name").val();
    let regLastName = $("#reg-last-name").val();
    let regCountryCode = $("#reg-country-code").val();
    let regPhone = $("#reg-phone").val();
    let regBirthday = $("#reg-birthday").val();
    let arrayregBirthday = regBirthday.split(". ");
    regBirthday = `${arrayregBirthday[2]}-${arrayregBirthday[1]}-${arrayregBirthday[0]}`;
    let gender = $(`input[name="gender"]:checked`).val();
    let regEmailVal = $("#reg-email").val().toLowerCase();
    let regCountry = $("#reg-country").val();
    let regState = $("#reg-state").val();
    let regInstagram = "";
    let regInstagramVal = $("#reg-instagram").val();
    let customerId = $("#customer-id").val();
    if(regInstagramVal.length > 0){
      regInstagram = "https://www.instagram.com/"+regInstagramVal;
    }
    let regTwitter = "";
    let regTwitterVal = $("#reg-twitter").val();
    if(regTwitterVal.length > 0){
      regTwitter = "https://twitter.com/"+regTwitterVal;
    }
    let regFacebook = "";
    let regFacebookVal = $("#reg-facebook").val();
    if(regFacebookVal.length > 0){
      regFacebook = "https://www.facebook.com/"+regFacebookVal;
    }
    let condiciones = $("#reg-terms-conditions").is(":checked");
    let data = {
      "email":regEmailVal,
      "countryCode":regCountryCode,
      "phone":regPhone,
      "name":regName,
      "lastName":regLastName,
      "birthday":regBirthday,
      "gender":gender,
      "instagram": regInstagram,
      "twitter": regTwitter,
      "facebook": regFacebook,
      "country": regCountry,
      "state": regState,
      "customerId":customerId,
      "action": "firstUpdateAccount"
    }
    let url = 'https://sebastianyatra.com/apps/proxy';
    fetch(url, {
      method: 'POST', // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers:{
        'Content-Type': 'application/json'
      }
    }).then(res => res.json())
    .catch(error => createAccount2Error(error))
    .then(response => createAccount2Success(response));
  }else{
    if(res.status === "failed"){
       Swal.fire({
        title: 'El código no es válido.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      $("#code-verify").val("");
      $("#loader-ajax-per").fadeOut();
    }else{
      Swal.fire({
        title: 'Ocurrio un error intente mas tarde.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
      $("#code-verify").val("");
      $("#loader-ajax-per").fadeOut();
    }
    
  }
}

function verifyAccountError(err){
  console.log(err);
  Swal.fire({
    title: 'Ocurrio un error intente mas tarde.',
    html: '',
    onBeforeOpen: () => {
    },
    onClose: () => {
    }
  })
  $("#loader-ajax-per").fadeOut();
}
function verifyAccountSuccess(res){
  if(res.status === "success"){
    if(res.code == "0"){
      $("#page-content-veryfy-account-code-email").show();
      $("#page-content-veryfy-account").hide();
      $("#reg-email").val(res.email);
      $(".email-current").text(res.email.toLowerCase());
      $("#verify-email-code").val('')
    }else if(res.code == "1"){
      Swal.fire({
        title: 'Ya tienes una cuenta con nosotros.',
        html: 'Accede con tu correo y contraseña.',
        onBeforeOpen: () => {
        },
        onClose: () => {
          window.location.href = 'https://sebastianyatra.com/account/login';
        }
      })
    }else if(res.code == "2"){
      Swal.fire({
        title: 'Te enviamos un correo para activar tu cuenta.',
        html: 'Por favor revisa tu bandeja de entrada de correos.',
        onBeforeOpen: () => {
        },
        onClose: () => {
          window.location.href = 'https://sebastianyatra.com';
        }
      })
    }
  }else{
    Swal.fire({
      title: 'Ocurrio un error intente mas tarde.',
      html: '',
      onBeforeOpen: () => {
      },
      onClose: () => {
      }
    })
  } 
  $("#loader-ajax-per").fadeOut();
}

function verifyCodeEmailError(err){
  console.log(err);
  Swal.fire({
    title: 'Ocurrio un error intente mas tarde.',
    html: '',
    onBeforeOpen: () => {
    },
    onClose: () => {
    }
  })
  $("#loader-ajax-per").fadeOut();
}
function verifyCodeEmailSuccess(res){
  if(res.status === "success"){
    $("#email_code").val($("#verify-email-code").val())
    $("#page-content-create-account").show();
    $("#page-content-veryfy-account-code-email").hide();
    $("#page-content-veryfy-account").hide();
  }else{
    Swal.fire({
      title: res.message,
      html: '',
      onBeforeOpen: () => {
      },
      onClose: () => {
      }
    })
  } 
  $("#loader-ajax-per").fadeOut();
}

function createAccountError(err){
  console.log(err);
  Swal.fire({
    title: 'Ocurrio un error intente mas tarde.',
    html: '',
    onBeforeOpen: () => {
    },
    onClose: () => {
    }
  })
  $("#loader-ajax-per").fadeOut();
}
function createAccountSuccess(res){
  if(res.status === "success"){
    $("#reg-phone-code-pop").hide();
    localStorage.setItem("ReferralCode", '');
    Swal.fire({
      title: 'Se creo tu cuenta',
      html: '',
      onBeforeOpen: () => {
      },
      onClose: () => {
        $("#reg-name").val("");
        $("#reg-last-name").val("");
        $("#reg-phone").val("");
        $("#reg-birthday").val("");
        $("#reg-email").val("");
        $("#reg-password").val("");
        $("#reg-password2").val("");
        $("#reg-instagram").val("");
        $("#reg-twitter").val("");
        $("#reg-facebook").val("");
        $("#code-verify").val("");
        window.location.href = 'https://sebastianyatra.com/account/login';
      }
    })
  }else{
     if(res.status === "failed"){
       if(res.message = "Phone taken"){
        Swal.fire({
          title: 'El télefono ya esta en uso.',
          html: '',
          onBeforeOpen: () => {
          },
          onClose: () => {
          }
        })
      }else if(res.message = "Email taken"){
        Swal.fire({
          title: 'El correo ya esta en uso en otra cuenta.',
          html: '',
          onBeforeOpen: () => {
          },
          onClose: () => {
          }
        })
      }
    }else{
      Swal.fire({
        title: 'Ocurrio un error intente mas tarde.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
    }
  } 
  $("#loader-ajax-per").fadeOut();
}

function createAccount2Error(err){
  console.log(err);
  Swal.fire({
    title: 'Ocurrio un error intente mas tarde.',
    html: '',
    onBeforeOpen: () => {
    },
    onClose: () => {
    }
  })
  $("#loader-ajax-per").fadeOut();
}
function createAccount2Success(res){
  if(res.status === "success"){
    $("#reg-phone-code-pop").hide();
    Swal.fire({
      title: 'Se actualizaron los datos de tu cuenta',
      html: '',
      onBeforeOpen: () => {
      },
      onClose: () => {
        $("#reg-name").val("");
        $("#reg-last-name").val("");
        $("#reg-phone").val("");
        $("#reg-birthday").val("");
        $("#reg-email").val("");
        $("#reg-instagram").val("");
        $("#reg-twitter").val("");
        $("#reg-facebook").val("");
        $("#code-verify").val("");
        location.reload();
      }
    })
  }else{
    if(res.status === "failed"){
       if(res.message = "Phone taken"){
        Swal.fire({
          title: 'El télefono ya esta en uso.',
          html: '',
          onBeforeOpen: () => {
          },
          onClose: () => {
          }
        })
      }else if(res.message = "Email taken"){
        Swal.fire({
          title: 'El correo ya esta en uso en otra cuenta.',
          html: '',
          onBeforeOpen: () => {
          },
          onClose: () => {
          }
        })
      }
    }else{
      Swal.fire({
        title: 'Ocurrio un error intente mas tarde.',
        html: '',
        onBeforeOpen: () => {
        },
        onClose: () => {
        }
      })
    }
  } 
  $("#loader-ajax-per").fadeOut();
}

function updateAccountError(err){
  Swal.fire({
     title: 'No se actualizaron los datos.',
     html: 'Por favor recargue la página.',
     onBeforeOpen: () => {
     },
     onClose: () => {
       $(".loader-inline").remove();
       $("#Perfil > #accout-edit-inline > .edit-this > .btns > a > span > i").removeClass("hide");
     }
   })
   
}
function updateAccountSuccess(res){
  if(res.status === "success"){
    $(".loader-inline").remove();
    $("#Perfil > #accout-edit-inline > .edit-this > .btns > a > span > i").removeClass("hide");
  }else{
    Swal.fire({
        title: 'No se actualizaron los datos.',
        html: 'Por favor recargue la página.',
        onBeforeOpen: () => {
        },
        onClose: () => {
          $(".loader-inline").remove();
          $("#Perfil > #accout-edit-inline > .edit-this > .btns > a > span > i").removeClass("hide");
        }
    })
  } 
  $("#loader-ajax-per").fadeOut();
}

function getGameballError(err){
  $("#info-rewards > #info-api").append(
      `<p>
         No se obtuvieron  los datos del programa Forever Yatra. 
       </p>`);
   $("#info-rewards").css("display","inline-block");
}
function getGameballSuccess(res){
  if(res.displayName != undefined){
    //let date = new Date(res.creationDate);
    //let dateCreation = date.toLocaleString();
    //let dateOfBirth = new Date(res.dateOfBirth);
    //let birthday = dateOfBirth.toLocaleString();
    //let furbies = res.accFrubies;
    //let level = "";
    //let nivel = "";
    //let imgNivel = "";
    
    
    /*if(furbies > 0  && furbies < 33000){
      level = "Cool!";
      nivel = "Nivel 1";
      imgNivel = "https://cdn.shopify.com/s/files/1/0036/8892/3236/files/cool.png?v=1599776137";
    }else if(furbies >= 33000  && furbies < 66000){
      level = "Pro!";
      nivel = "Nivel 2";
      imgNivel = "https://cdn.shopify.com/s/files/1/0036/8892/3236/files/pro.png?v=1599776137";
    }else if(furbies >= 66000){
      level = "Crack!";
      nivel = "Nivel 3";
      imgNivel = "https://cdn.shopify.com/s/files/1/0036/8892/3236/files/crack.png?v=1599776137";
    }*/
    /*<p>
      <span>Eres fan desde:</span> ${dateCreation}
    </p>*/
    $("#info-rewards").css("display","inline-block");
    $("#info-rewards > #info-api").append(
      `<div>
         <div>
           
           <p>
             <span>Fan ID:</span> ${res.displayName}
           </p>
           <div class="block">
             <div>
               <img src="${res.level.iconPath}" alt="nivel"/>
               <span>Nivel</span>
             </div>
             <div>
               <p>${res.level.name}</p>
               <span>Nivel ${res.level.levelOrder}</span>
             </div>
           </div>
           <div class="block">
             <div>
               <img src="https://cdn.shopify.com/s/files/1/0036/8892/3236/files/frubies-icon.png?v=1599064884" alt="nivel"/>
               <span>Score</span>
             </div>
             <div>
               <p>
                 ${res.score.scoreBalance}
               </p>
               <span></span>
             </div>
           </div>
           <div class="block">
             <div>
               <img src="https://cdn.shopify.com/s/files/1/0036/8892/3236/files/points-icon.png?v=1599064884" alt="nivel"/>
               <span>Puntos</span>
             </div>
             <div>
               <p>
                 ${res.points.pointsBalance}
               </p>
               <span>${res.points.pointsValue} ${res.points.currency}</span>
             </div>
           </div>
         </div>
       </div>`
    );
    
  }else{
    $("#info-rewards > #info-api").append(
      `<p>
         No se obtuvieron  los datos del programa Forever Yatra. 
       </p>`);
    $("#info-rewards").css("display","inline-block");
  }
}

function getStreamingError(err){
  console.log(err)
   $("#streaming-events-octo").append(
    `<p>
      No se obtuvieron eventos. 
    </p>`);
   $("#streaming-events-octo").css("display","inline-block");
}
function getStreamingSuccess(res){
  if(res.status == "success"){
    $.each(res.data,function(index, value){
      
      let currStartDate = value.start_date;
      let rescurrStartDate = currStartDate.split(" ");
      let currStarHour = rescurrStartDate[1];
      let currAllStartDate = rescurrStartDate[0];
      let currAllStartDateArr = currAllStartDate.split("-");
      let currStartDay = currAllStartDateArr[2];
      let currStartMonth = currAllStartDateArr[1];
      let currStartYear = currAllStartDateArr[0];
      let newDateStart = `${currStartDay}/${currStartMonth}/${currStartYear} ${currStarHour}`
      
      
      let currEndDate = value.end_date;
      let rescurrEndDate = currEndDate.split(" ");
      let currEndHour = rescurrEndDate[1];
      let currAllEndDate = rescurrEndDate[0];
      let currAllEndDateArr = currAllEndDate.split("-");
      let currEndDay = currAllEndDateArr[2];
      let currEndMonth = currAllEndDateArr[1];
      let currEndYear = currAllEndDateArr[0];
      let newDateSEnd = `${currEndDay}/${currEndMonth}/${currEndYear} ${currEndHour}`
      $("#streaming-events-octo").append(
        `<div class="event"  data-event-id="${value.id}">
           <a data-product-url="${value.product_url}" data-product-title="${value.product_title}" data-event-id="${value.id}">
             <img src="${value.cover}" alt="event" />
             <span></span>
             <img src="https://cdn.shopify.com/s/files/1/0036/8892/3236/files/boton-de-play.svg?v=1602099062" class="play" />
           </a>
           <div class="videoWrapper">
           </div>
           <p class="date">
             <span>Inicia: </span>${newDateStart} - 
             <span>Termina: </span>${newDateSEnd}
           </p>
           <p class="title">${value.title}</p>
           <p class="description">${value.description}</p>
         </div>`
      );
    });
  }else{
    $("#streaming-events-octo").append(
    `<p>
      No se obtuvieron eventos. 
    </p>`);
    $("#streaming-events-octo").css("display","inline-block");
  }
  /*if(res.displayName != undefined){
    
    $("#info-rewards").css("display","inline-block");
    $("#info-rewards > #info-api").append(
      `<div>
         <div>
           
           <p>
             <span>Fan ID:</span> ${res.displayName}
           </p>
           <div class="block">
             <div>
               <img src="${res.level.iconPath}" alt="nivel"/>
               <span>Nivel</span>
             </div>
             <div>
               <p>${res.level.name}</p>
               <span>Nivel ${res.level.levelOrder}</span>
             </div>
           </div>
           <div class="block">
             <div>
               <img src="https://cdn.shopify.com/s/files/1/0036/8892/3236/files/frubies-icon.png?v=1599064884" alt="nivel"/>
               <span>Score</span>
             </div>
             <div>
               <p>
                 ${res.score.scoreBalance}
               </p>
               <span></span>
             </div>
           </div>
           <div class="block">
             <div>
               <img src="https://cdn.shopify.com/s/files/1/0036/8892/3236/files/points-icon.png?v=1599064884" alt="nivel"/>
               <span>Puntos</span>
             </div>
             <div>
               <p>
                 ${res.points.pointsBalance}
               </p>
               <span>${res.points.pointsValue} ${res.points.currency}</span>
             </div>
           </div>
         </div>
       </div>`
    );
    
  }else{
    $("#info-rewards > #info-api").append(
      `<p>
         No se obtuvieron  los datos del programa Forever Yatra. 
       </p>`);
    $("#info-rewards").css("display","inline-block");
  }*/
}

function streamingAccessError(err){
  console.log(err);
  Swal.fire({
    title: 'Ocurrio un error intente mas tarde.',
    html: '',
    onBeforeOpen: () => {
    },
    onClose: () => {
    }
  })
  $("#loader-ajax-per").fadeOut();
}
function streamingAccessSuccess(res, currEventId,  productUrl, productTitle){
  if(res.status === "success"){
    $(`.event[data-event-id="${currEventId}"] a`).remove();
    $(`.event[data-event-id="${currEventId}"] .videoWrapper`).html(`${res.data.embedcode}`);
    $(`.event[data-event-id="${currEventId}"] .videoWrapper`).fadeIn();
  }else{
    $("#shopify-section-streaming-events-octo").append(`
      <div id="popup-streaming-octocode" data-event-id="${currEventId}">
        <div>
          <span class="close">
            <img src="https://cdn.shopify.com/s/files/1/0036/8892/3236/files/boton-cerrar.svg?v=1602111636" alt="x" />
          </span>
          <p>
            Ingresa código de evento
          </p>
          <input type="text" placeholder="Código" />
          <button class="btn">
             Ver contenido
          </button>
          <a href="${productUrl}" target="_blank">
            Consigue el código
          </a>
        </div>
      </div>
    `);
  }
  $("#loader-ajax-per").fadeOut();
}

function validateCodeAccessError(err){
  console.log(err);
  Swal.fire({
    title: 'Ocurrio un error intente mas tarde.',
    html: '',
    onBeforeOpen: () => {
    },
    onClose: () => {
    }
  })
  $("#loader-ajax-per").fadeOut();
}
function validateCodeAccessSuccess(res, currEventId){
  if(res.status === "success"){
    $("#popup-streaming-octocode").remove();
    $(`.event[data-event-id="${currEventId}"] a`).remove();
    $(`.event[data-event-id="${currEventId}"] .videoWrapper`).html(`${res.data.embedcode}`);
    $(`.event[data-event-id="${currEventId}"] .videoWrapper`).fadeIn();
  }else{
    Swal.fire({
      title: 'Código incorrecto',
      html: 'El código que envio es incorrecto o ya esta en uso',
      onBeforeOpen: () => {
      },
      onClose: () => {
      }
    })
  }
  $("#loader-ajax-per").fadeOut();
}

function changePWError(err){
  console.log(err);
  Swal.fire({
    title: 'Ocurrio un error intente mas tarde.',
    html: '',
    onBeforeOpen: () => {
    },
    onClose: () => {
    }
  })
  $("#loader-ajax-per").fadeOut();
}
function changePWSuccess(res, currEventId){
  if(res.status === "success"){
    Swal.fire({
      title: 'Se cambio su contraseña',
      html: 'Inicie sesión con su nueva contraseña',
      onBeforeOpen: () => {
      },
      onClose: () => {
        window.location.href = "/account/logout";
      }
    })
  }else{
    Swal.fire({
      title: 'Ocurrio un error intente mas tarde.',
      html: '',
      onBeforeOpen: () => {
      },
      onClose: () => {
      }
    })
  }
  $("#loader-ajax-per").fadeOut();
}

var tabLinks = document.querySelectorAll(".tablinks");
var tabContent = document.querySelectorAll(".tabcontent");
tabLinks.forEach(function(el) {
  el.addEventListener("click", openTabs);
});
function openTabs(el) {
  var btnTarget = el.currentTarget;
  var country = btnTarget.dataset.country;

  tabContent.forEach(function(el) {
    el.classList.remove("active");
  });

  tabLinks.forEach(function(el) {
    el.classList.remove("active");
  });

  document.querySelector("#" + country).classList.add("active");

  btnTarget.classList.add("active");
}
/*
webshims.setOptions('mediaelement', {
    replaceUI: 'auto',
    jme: {
        //barTemplate default in 1.14.4: '<div class="play-pause-container">{{play-pause}}</div><div class="playlist-container"><div class="playlist-box"><div class="playlist-button-container">{{playlist-prev}}</div><div class="playlist-button-container">{{playlist-next}}</div></div></div><div class="currenttime-container">{{currenttime-display}}</div><div class="progress-container">{{time-slider}}</div><div class="duration-container">{{duration-display}}</div><div class="mute-container">{{mute-unmute}}</div><div class="volume-container">{{volume-slider}}</div><div class="chapters-container"><div class="chapters-controls mediamenu-wrapper">{{chapters}}</div></div><div class="subtitle-container mediamenu-wrapper"><div class="subtitle-controls">{{captions}}</div></div><div class="mediaconfig-container"><div class="mediaconfig-controls mediamenu-wrapper">{{mediaconfigmenu}}</div></div><div class="fullscreen-container">{{fullscreen}}</div>'
        barTemplate: '<div class="play-pause-container">{{play-pause}}</div><div class="progress-container">{{time-slider}}</div><div class="currenttime-container">{{currenttime-display}}</div><div class="duration-container">{{duration-display}}</div><div class="mute-container">{{mute-unmute}}</div><div class="fullscreen-container">{{fullscreen}}</div>'
    }
});
webshims.polyfill('mediaelement');
//get the current default/active barTemplate:
webshim.ready('mediacontrols', function(){
    if(window.console){
        console.log(webshim.cfg.mediaelement.jme.barTemplate);
    }
});*/

function DDMMYYYY(value, event) {
  let newValue = value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');

  const dayOrMonth = (index) => index % 2 === 1 && index < 4;

  // on delete key.  
  if (!event.data) {
    return value;
  }

  return newValue.split('').map((v, i) => dayOrMonth(i) ? v + '/' : v).join('');;
}